/**
 * Where Trainings live in this portal's URL (2026-09-17). One place, so the
 * page's rows and the reader's Back cannot drift from the routes in `App.tsx`.
 */
export const TRAININGS_PATH = "/trainings";

/** One training, opened in the ordinary article reader. */
export function trainingPath(slug: string): string {
  return `${TRAININGS_PATH}/${encodeURIComponent(slug)}`;
}
